export const GET_APPROVED_QC_PLAN = 'qc-plan/GET_APPROVED_QC_PLAN';
export const GET_QC_PLAN_DETAIL = 'qc-plan/GET_QC_PLAN_DETAIL';
export const GET_QC_PLAN_FLAG = 'qc-plan/GET_QC_PLAN_FLAG';
export const GET_QC_PLAN_DETAIL_OPTION = 'qc-plan/GET_QC_PLAN_DETAIL_OPTION';



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/qc-plan/qc-plan.action.const.ts